import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Home";
import HomePage from "@/views/HomePage";
import AboutUs from "@/views/AboutUs";
import CustomerCase from "@/views/Case/CustomerCase";
import CaseDetails from "@/views/Case/CaseDetails";
import NewsInformation from "@/views/news/NewsInformation";
import NewsInformationDetails from "@/views/news/newsInformationDetails";

import Enterprise from "@/views/productIntroduction/Enterprise";
import ProductionManagement from "@/views/productIntroduction/ProductionManagement";
import ElectronicCommerce from "@/views/productIntroduction/ElectronicCommerce";
import MobileTerminal from "@/views/productIntroduction/MobileTerminal";
Vue.use(Router);

const router = new Router({
  mode: "history",
  // base:'',
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      children: [
        {
          path: "/",
          name: "homePage",
          component: HomePage,
          
        },
        {
          path: "/customerCase",
          name: "customerCase",
          component: CustomerCase,
        },
        {
          path: "/caseDetails",
          name: "caseDetails",
          component: CaseDetails,
        },
        {
          path: "/enterpriseWebsite",
          name: "enterpriseWebsite",
          component: Enterprise,
        },
        {
          path: "/productionManagement",
          name: "productionManagement",
          component: ProductionManagement,
        },
        {
          path: "/electronicCommerce",
          name: "electronicCommerce",
          component: ElectronicCommerce,
        },
        {
          path: "/mobileTerminal",
          name: "mobileTerminal",
          component: MobileTerminal,
        },
        {
          path: "/newsInformation",
          name: "newsInformation",
          component: NewsInformation,
        },
        {
          path: "/newsInformationDetails",
          name: "newsInformationDetails",
          component: NewsInformationDetails,
        },
        {
          path: "/aboutUs",
          name: "aboutUs",
          component: AboutUs,
        },
        
      ]
    }
  ]
});
router.beforeEach(function(to, from, next) {
  console.log(to);
  if (to.path == "/homePage") {
    next("/");
  } else {
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js